import { FC } from 'react'

import type { IContentSpaceSession } from 'components/contentspace/types'
import { formatScoreDisplay } from 'components/contentspace/utils/score'
import Button from 'components/uiKit/Button'
import Card from 'components/uiKit/Card'
import { KitSize } from 'components/uiKit/KitTypes'
import PlayerHeader from 'routes/portal/ContentSpacePublic/components/PlayerHeader'
import { testProps } from 'utils/test/qaData'

import * as s from './SessionResume.module.scss'

interface ISessionResumeProps {
  session: IContentSpaceSession
  courseName: string
  portalLandingUrl: string
  portalRedirectUrl?: string
  onContinue: () => void
  onStartNew: () => void
}

export const SessionResume: FC<ISessionResumeProps> = ({
  session,
  courseName,
  portalLandingUrl,
  portalRedirectUrl,
  onContinue,
  onStartNew,
}) => {
  return (
    <div className={s.root}>
      <PlayerHeader
        backRedirectUrl={portalRedirectUrl}
        backUrl={portalLandingUrl}
        courseName={courseName}
        progress={session.progress}
        userName={session.userName || session.email || undefined}
      />
      <div className={s.cardWrapper}>
        <div className={s.cardContainer}>
          <Card hovered={false} name='sessionResume' size={KitSize.L} fill fluid shadow>
            <div className={s.header}>
              <h3 className={s.title}>Resume Course</h3>
              <p className={s.description}>We found a previous session for this course.</p>
            </div>

            <div className={s.sessionDetails}>
              <div className={s.detailRow}>
                <span className={s.detailLabel}>Status</span>
                <span
                  className={s.detailValue}
                  {...testProps({ el: 'typography', name: 'status', value: session.status })}
                >
                  {session.status}
                </span>
              </div>
              <div className={s.detailRow}>
                <span className={s.detailLabel}>Progress</span>
                <span
                  className={s.detailValue}
                  {...testProps({ el: 'typography', name: 'progress', value: session.progress })}
                >
                  {session.progress}%
                </span>
              </div>
              {session.score !== null && (
                <div className={s.detailRow}>
                  <span className={s.detailLabel}>Score</span>
                  <span
                    className={s.detailValue}
                    {...testProps({ el: 'typography', name: 'score', value: session.score })}
                  >
                    {formatScoreDisplay(session.score, session.scoreMin, session.scoreMax)}
                  </span>
                </div>
              )}
              <div className={s.detailRow}>
                <span className={s.detailLabel}>Last Access</span>
                {/* PO сверяет `value` с сырым ISO-временем из API — поэтому
                  `value` это `session.lastAccessAt`, а не локализованная строка. */}
                <span
                  className={s.detailValue}
                  {...testProps({
                    el: 'typography',
                    name: 'lastAccess',
                    value: session.lastAccessAt ?? '',
                  })}
                >
                  {new Date(session.lastAccessAt || '').toLocaleString()}
                </span>
              </div>
              {session.email && (
                <div className={s.detailRow}>
                  <span className={s.detailLabel}>User</span>
                  <span
                    className={s.detailValue}
                    {...testProps({ el: 'typography', name: 'user', value: session.email })}
                  >
                    {session.email}
                  </span>
                </div>
              )}
            </div>

            <div className={s.actions}>
              <Button name='continueSession' onClick={onContinue}>
                Continue Session
              </Button>
              <Button name='startNewSession' onClick={onStartNew} styleType='secondary'>
                Start New Session
              </Button>
            </div>
          </Card>
        </div>
      </div>
    </div>
  )
}
